import { FormPasswordField } from '@map/components/formControls/controlled';
import { guestLinks } from '@map/components/GuestArea/links';
import { buildApiUrl } from '@map/hooks/baseApi';
import { makeStyles } from '@map/theme';
import { userValidationSchema } from '@map/validators/user';
import useToggleState from '@shared/hooks/useToggleState';
import { Form } from '@shared/lib/form';
import { SubmitButton } from '@shared/lib/form/Form';
import Button from '@ui/Button';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import PublicPage from '../Authentication/shared/PublicPage';
import PublicPageHeader from '../Authentication/shared/PublicPageHeader';

const validationSchema = userValidationSchema.pick(['password']);
const emptyValues = {
  password: '',
};
const useStyles = makeStyles(({ spacing }) => ({
  button: {
    marginTop: spacing(6),
  },
}));

const ResetPassword = () => {
  const location = useLocation();
  const history = useHistory();
  const [submitted, toggleSubmitted] = useToggleState(false);
  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get('token');
  const returnTo = urlParams.get('returnTo');
  const { classes } = useStyles();

  if (!token) {
    return <Redirect to="/" />;
  }

  const handleSubmit = async ({ password }: typeof emptyValues) => {
    try {
      const { data } = await axios.put<{ success: boolean }>(buildApiUrl('password_reset'), {
        token,
        password,
      });
      const { success } = data;
      if (success) {
        toggleSubmitted();
      }
    } catch {
      console.warn('Something went wrong');
    }
  };

  return (
    <PublicPage>
      <PublicPageHeader
        title={<FormattedMessage id="reset_password.title" />}
        subtitle={
          submitted ? (
            <FormattedMessage id="reset_password.your_password_has_been_updated" />
          ) : (
            <FormattedMessage id="registration.password_suggestion" />
          )
        }
      />
      {submitted ? (
        <Button
          className={classes.button}
          fullWidth={true}
          size="medium"
          onClick={() => {
            if (returnTo) {
              // returnTo is a full URL, possibly
              // on a different host so we need to use window.
              window.location.href = returnTo;
            } else {
              history.push(guestLinks.authentication());
            }
          }}
        >
          <FormattedMessage id="registration.go_back_to_login" />
        </Button>
      ) : (
        <Form
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          initialValues={emptyValues}
        >
          <FormPasswordField name="password" autoComplete="new-password" />
          <SubmitButton fullWidth={true} size="medium">
            <FormattedMessage id="reset_password.submit_button" />
          </SubmitButton>
        </Form>
      )}
    </PublicPage>
  );
};

export default ResetPassword;
